import { ValidatorFn, FormGroup } from '@angular/forms';
import { ISearchAccountContract } from '@domain/interfaces';

export function searchAccountContractValidator(): ValidatorFn {
  return function validate(contract: FormGroup) {
    const {
      will_attend,
      attendant_name,
      attendant_phone,
      visitor_data_policy_accepted,
    } = contract.value as ISearchAccountContract;

    const validations = [
      !!attendant_name,
      !!attendant_phone,
      visitor_data_policy_accepted,
    ];

    if (will_attend === false && !validations.every(Boolean)) {
      return { attend_required: 'Required' };
    }

    return null;
  };
}
